import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\">\n<path d=\"M15.125 13.125L9.54688 7.5L15.125 1.92188C15.5938 1.5 15.5938 0.796875 15.125 0.375C14.7031 -0.09375 14 -0.09375 13.5781 0.375L8 5.95312L2.375 0.375C1.95312 -0.09375 1.25 -0.09375 0.828125 0.375C0.359375 0.796875 0.359375 1.5 0.828125 1.92188L6.40625 7.5L0.828125 13.125C0.359375 13.5469 0.359375 14.25 0.828125 14.6719C1.25 15.1406 1.95312 15.1406 2.375 14.6719L8 9.09375L13.5781 14.6719C14 15.1406 14.7031 15.1406 15.125 14.6719C15.5938 14.25 15.5938 13.5469 15.125 13.125Z\" fill=\"#78909C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/close.svg
// module id = WbSG
// module chunks = 13